import React, { useEffect, useState } from 'react';
import Divider from './common/Divider';
import NavBar from './common/NavBar';
import forward from '../../assets/arrow_forward_ios.png';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { apiUrl, getStarted } from '../services/operations/authAPI';
import Loader from "../Loader/Loader";

const GetStarted = () => {
  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [blockedDomain, setBlockedDomain] = useState([]);
  const [error, setError] = useState("");
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.auth.loading);


  const blockedDomainList = async () => {
    const response = await dispatch(apiUrl());
    if (response?.status === 200) {
      setBlockedDomain(response.data.blockdomain || []);
    }
  };

  useEffect(() => {
    blockedDomainList();
  }, []);

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    
    if (emailPattern.test(emailValue)) {
      setIsValid(true);
      setError("");
    } else {
      setIsValid(false);
    }
  };

  const handleVerifyEmail = async () => {
    const domain = email.split("@")[1]?.toLowerCase();

    if (blockedDomain.some(blocked => domain.endsWith(blocked))) {
      setError("This email domain is not allowed.Please use a professional email.");
      return;
    }
    setError("");
    if (isValid) {
      const payload = { email };
      await dispatch(getStarted(payload, navigate, email));
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleVerifyEmail(); 
    }
  };

  return (
    <div className='get-started'>
      {loading && <Loader />}
      <NavBar />
      <div className='get-started-content'>
        <p className='get-started-heading'>Create your free account</p>
        <p className='get-started-subheading'>100% free. No credit card needed</p>
      </div>

      <div className='registation-email-desc-text'>
        Email address (we recommend a professional email)
      </div>

      <div className="email-input-container">
        <input
          type="email"
          className="email-input"
          value={email}
          onChange={handleEmailChange}
          onKeyUp={handleKeyPress}
        />
        <div className={`normal-line ${isValid ? '' : 'disabled'}`}></div>
      </div>

      {error && <p className="error-message" style={{ color: 'red', fontSize: '14px',margin:"1px 0px 1px 0px"}}>{error}</p>}

      <button
        className={`button-theme verifyEmailButton ${isValid ? '' : 'disabled'}`}
        onClick={handleVerifyEmail}
        disabled={!isValid}
      >
        <span style={{ display: "flex", gap: "20px", alignItems: "center", justifyContent: "center" }}>
          Verify Email <img src={forward} alt='forward' />
        </span>
      </button>

      <div className='email-privacy-desc'>
        We’re committed to your privacy. 1800hired uses the information you provide to us to contact you about our 
        relevant content, products, and services. You may unsubscribe from these communications at any time.
      </div>
      <Divider />
      <p className="login-header-desc">
        Have an account? <span 
          style={{ color: "rgba(26, 76, 255, 1)", fontWeight: "600", cursor: "pointer" }}
          onClick={() => navigate("/login")}
        >Sign In</span>
      </p>
    </div>
  );
}

export default GetStarted;
